import React from 'react';
import { Grid, Typography } from '@mui/material';

const StatisticCount = props => {
  const { IconComponent, label, count } = props;
  return (
    <Grid
      container
      spacing={1}
      style={{ color: '#757575' }}
      sx={{
        justifyContent: "center",
        alignItems: "center"
      }}>
      <Grid style={{ height: 28.7 }}>
        <IconComponent style={{ fontSize: 20.7 }} />
      </Grid>
      {label && (
        <Grid>
          <Typography>{label}</Typography>
        </Grid>
      )}
      <Grid>
        <Typography>{count || 0}</Typography>
      </Grid>
    </Grid>
  );
};

export default StatisticCount;
